const getColor = (t, color, disabled) => disabled ? t.palette.grey[400] : color === "error" ? t.palette.error.main : color === "success" ? t.palette.success.main : void 0;
export {
  getColor
};
//# sourceMappingURL=getColor.js.map
